export enum AcaoPropostaEnum {
  APROVAR = 'Aprovar',
  PENDENCIAR = 'Pendenciar',
  REPROVAR = 'Reprovar',
  FINALIZADA = 'Finalizada',
}

